import {ReactComponent as FULL_SCREEN} from "../../images/full-screen-icon.svg";

import React, {useState} from "react";
import {YuJaImageViewer} from "../../components/standardization/YuJaImageViewer";
import classes from "./PollReady.module.css";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {Button} from "@base-ui/react/button";
import {getSafeURL} from "../../utils/helpers";
import { useTranslation } from "react-i18next";


export default function ImageViewer({imageURL, alt, size=270, styles={}, width, height, ...props}) {
    const { t } = useTranslation();
    // const [showManageImageIcon, setShowManageImageIcon] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    // const [isTouchAble, setIsTouchAble] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    // const [isSmall, setIsSmall] = useState(false);

    const safeImageURL = getSafeURL(imageURL);

    let imageWidth = width ? width : size;
    let imageHeight = height ? height : size;

    let propsCopy = {...props};
    if (!propsCopy.hasOwnProperty("aria-labelledby") && !propsCopy.hasOwnProperty("aria-label")) {
        propsCopy["aria-label"] = t("questionBuilder.enlargeImageText");
    }


    // useEffect(() => {
    //     setIsTouchAble(window.navigator.maxTouchPoints > 0);
    //
    // }, [window.navigator.maxTouchPoints]);

    // useEffect(() => {
    //     const img = new Image();
    //     img.src = imageURL;
    //     img.onload = () => {
    //         if (img.width <= 100 && img.height <= 100) {
    //             setIsSmall(true);
    //         } else {
    //             setIsSmall(false);
    //         }
    //     };
    //
    //     return () => {
    //         setIsLoaded(false);
    //     }
    // }, [imageURL]);


    const handleView = (e) => {
        e.stopPropagation();
       setShowViewModal(true);
    };

    const handleClose = () => {
        setShowViewModal(false);
        // onMouseLeave();
    };

    // const onMouseEnter = () => {
    //     setShowManageImageIcon(true);
    // };
    //
    // const onMouseLeave = () => {
    //     setShowManageImageIcon(false);
    // };

    const onClickImage = (e) => {
        handleView(e);
    }

    const onLoad = (e) => {
        setIsLoaded(true);
    }

    if (!isLoaded) {
       return (
           <>
               <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                   <Skeleton borderRadius={3} height={imageHeight} width={imageWidth}/>
               </SkeletonTheme>

               <img
                   onLoad={onLoad}
                   alt={alt ? alt : t("accessibility.defaultImageAlt")}
                   src={safeImageURL}
                   style={{width: 100, height: 100, display: "none"}}
               />
           </>
       );
    }


    return (
        <>
            <YuJaImageViewer showViewer={showViewModal} setShowViewer={setShowViewModal} onHandleClose={handleClose} imageURL={safeImageURL}/>
            <Button
                onClick={onClickImage}
                className={classes.imageContainer}
                style={{
                    position: "relative",
                    width: imageWidth ? imageWidth : undefined,
                    height: imageHeight ? imageHeight : undefined,
                    display: isLoaded ? undefined : "none",
                    ...styles
                }}
                {...propsCopy}
            >
                <img
                    alt={alt ? alt : t("accessibility.defaultImageAlt")}
                    src={safeImageURL}
                    style={{maxWidth: "100%", maxHeight: "100%", cursor: "pointer"}}
                />
            </Button>
        </>

    );
}